import React, { createContext, useContext, useMemo } from 'react';
import { mulberry32, hashString, newSeed, Rng } from './rng';

interface ChaosState {
  visitSeed: number;
  rngFor: (key: string) => Rng; // stable per (visit, key)
}

const ChaosCtx = createContext<ChaosState | null>(null);

export const ChaosProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const value = useMemo<ChaosState>(() => {
    const visitSeed = newSeed();
    return { visitSeed, rngFor: (key: string) => mulberry32(visitSeed ^ hashString(key)) };
  }, []);
  return <ChaosCtx.Provider value={value}>{children}</ChaosCtx.Provider>;
};

export function useChaos(): ChaosState {
  const ctx = useContext(ChaosCtx);
  if (!ctx) throw new Error('useChaos must be used within <ChaosProvider>');
  return ctx;
}
